import { useEffect } from "react";
import { useShareTarget } from "../hooks/useShareTarget";
import { useAppModals } from "../hooks/useAppModals";
import { useAuth } from "../hooks/useAuth";

/**
 * Handles Web Share Target API - when user shares a link from Instagram, browser, etc.
 * - Logged in: Opens AddLinkModal with the shared URL so user can pick a group and save.
 * - Logged out: Opens AuthModal first; after sign-in, opens AddLinkModal with the URL.
 */
export const ShareTargetHandler = () => {
  const { shareData, clearShareData } = useShareTarget();
  const { openAddLinkModal, openAuthPrompt, isAddLinkModalOpen, isAuthPromptOpen } = useAppModals();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!shareData?.url) return;

    if (!isAuthenticated) {
      if (!isAuthPromptOpen) {
        openAuthPrompt();
      }
      return;
    }

    if (!isAddLinkModalOpen) {
      openAddLinkModal(shareData.url, undefined);
      clearShareData();
    }
  }, [shareData?.url, isAuthenticated, isAddLinkModalOpen, isAuthPromptOpen, openAddLinkModal, openAuthPrompt, clearShareData]);

  return null;
};
